export const API_BASE_BASEPOINT: any = {
  ADDR_SUGG: 'address-suggestion/',
  CATELOG_MGMT: 'catalogue-management/',
  CART_MGMT: 'basket-management/',
  CUSTOMER: 'customer-management/',
  STORYBLOK: 'storyblok-management/',

  /* Login Service */
  LOGINMETHOD: "login-method",
  LOGIN: "login",
  MTANLOGIN: "login-mtan",
  LOGINPOLICY: "my.policy",
  LOGIN_OTP: 'login-otp',
  LOGIN_MFA: 'login-mfa',
  CHATTOKEN: 'auth/chattoken'
};

export const APIResourceConstants = {
  X_SUN_CHAL: 'ESHOP',
  LINE_TABLEV2: 'v2/offer',
  LINE_TABLEV3: 'v3/offer', 
  CREATE_CARTV2: 'carts/v2',
  CREATE_CARTV3: 'carts/v3',
  SUBSCRIPTION: '?subscriptionType=',
  VOUCHER_PROMOTIONS: 'v1/voucher-promotions',
  HARDWARES: 'v1/hardwares?filterSearchOption.id=',
  HARDWARE_DEVICES:
    'v1/hardwares?filterSearchOption.id=parent__true&filterSearchOption.id=residual__true&filterSearchOption.id=category__sellableMobilePostpaidDevices&priceRequired=false&filterSearchOption.id=',
  TV_SERVICE_OPTIONS_V2: 'v2/service-optionByCategory?category=category__popUpTvOptions',
  CUSTOMER_EVENTS: 'events',   // PEGA tracking constants
  THREE_SCALE_API_KEY: 'THREE_SCALE_API_KEY', //for MIA
  STORIES: 'rest/cms/stories', //for MIA
  /* multi-item accessory related endpoints */
  RECOMMENDED_ACCESSORIES: 'carts/v3/recommendation',
  UPDATE_CART: 'carts/v3/'
};
export const SBENDPOINT: any = {
  SLUG_URL: 'rest/cms/singlestory',
  CONSTANTS_KEYS: 'rest/cms/dsource_entries?datasource=one-ecommerce-constant-keys',
  STORIES_URL: 'rest/cms/stories'
};
